import { createAction } from '@reduxjs/toolkit';
import { RequestError, UserFilter } from 'types';
import { State } from './types';

export const fetchUsers = createAction('Users/fetch', (user?: UserFilter) => ({
  payload: user,
}));

export const fetchedUsers = createAction('users/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const exportUsers = createAction(
  'users/export',
  (payload?: Omit<UserFilter, 'pageNumber' | 'maxResultPage'>) => {
    return {
      payload,
    };
  }
);

export const exportedUsers = createAction('users/exported', (data?: ArrayBuffer, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const setFilters = createAction('users/setFilters', (payload: UserFilter) => ({
  payload,
}));

export const resetFilters = createAction('users/resetFilters');

export default {
  fetchedUsers,
  fetchUsers,
  exportUsers,
  exportedUsers,
  setFilters,
  resetFilters,
};
